import { BrandingStyle, Link, useModel, DisabledPrompt } from "@bcm-dev/bcms-vite";
import { WidgetContainer, WidgetView } from "components/shared";
import React from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function AlertsWidget
 * @return {React.Component}
 * @exported true
 * @description The Alerts promotional widget shown on the Account Summary page
 */
export default function AlertsWidget(props) {
  const { branding } = useModel();
  const notifiVersion = branding.options.notifi_version_abi22;
  
  const alertsPath = notifiVersion === "Native Alerts" ? "/alerts" : "/notifications";
  const isDisabled = notifiVersion === "Disabled";

  return (
    <WidgetContainer className="alerts-widget show-on-desktop">
      <WidgetView text="Alerts" data-point="Alerts_Widget">
        <div className="flex-container flex-horizontal align-center alerts-widget-title-row" data-point="Alerts_Stay_Alert">
          <SVGAsset id="AlertTriangleSolidIcon" className="alerts-widget-icon set-width" />
          Stay Alert
        </div>
        <p className="alerts-widget-description" data-point="Alerts_Description">
          Know about changes to your finances and online security. Choose when and what alerts you get by email or text message.
        </p>
        <BrandingStyle
          style={{ color: "links_abi22" }}
          element={
            <>
              { !isDisabled && <Link to={alertsPath} dataPoint="Alerts_Enroll_Or_Manage">
                Enroll or Manage
              </Link> }

              { isDisabled && <DisabledPrompt>
                  <Link to="" dataPoint="Alerts_Enroll_Or_Manage">
                    Enroll or Manage
                  </Link>
                </DisabledPrompt>}
            </>
          }
        />
      </WidgetView>
    </WidgetContainer>
  );
}
